import React from "react";
import Header from "../pages/Header";
import Footer from "../pages/Footer";
import topback from "../images/beetitle.png";

function Vision() {
  return (
    <>
      <Header />

      {/* Title Section with background */}
      <section
        className="content-section title-top"
        style={{ backgroundImage: `url(${topback})` }}
      >
        <div className="pattern-overlay">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 title-heading">
                <h2>Vission & Mission</h2>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="container mt-5">
        <div className="row">
          {/* Basic Information */}
           <div className="row justify-content-center mb-4">
          <div className="col-md-12">
            <div className="committee-card">
              <div className="card-header text-center">
                <h3 className="m-0">Institution Development Plan (Basic Information)</h3>
              </div>
              &nbsp;
              <div className="card-body d-flex justify-content-center">
                <table className="table table-bordered table-striped table-hover" style={{ width: "75%" }}>
                  <tbody>
                    <tr>
                      <th>Name of Institution</th>
                      <td>Sant Dhangu Wala Gujjar Govt. College Beetan</td>
                    </tr>
                    <tr>
                      <th>Type of Institution</th>
                      <td>Government College</td>
                    </tr>
                    <tr>
                      <th>Status of Institution</th>
                      <td>Government</td>
                    </tr>
                    <tr>
                      <th>Name of Head of Institution</th>
                      <td>Dr. Sunita Goyal - Mobile No. 9418614744</td>
                    </tr>
                    <tr>
                      <th>Email ID of Head</th>
                      <td><u>principalgcbeetan@gmail.com</u></td>
                    </tr>
                    <tr>
                      <th>IDP Coordinator</th>
                      <td>Prof. Gurdev Singh - Mobile No. 9418151625</td>
                    </tr>
                    <tr>
                      <th>Email ID of Coordinator</th>
                      <td><u>guru.4702c@gmail.com</u></td>
                    </tr>
                    <tr>
                      <th>IDP Assistant Coordinator</th>
                      <td>Dr. Gaurav Sharma - Mobile No. 9736204600</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>


          {/* Vision */}
          <div className="col-md-12 mt-4">
            <div className="committee-card">
              <div className="card-header">
                <h3 className="m-0">Institutional Vision</h3>
              </div>
              &nbsp;
              <div className="card-body">
                <p>
                  Vision of SDWG Govt. College Beetan is to provide multi-dimensional education to its students. It fulfills this objective not only through classroom instructions that are imparted in different courses of study, but also supplements the human dimension in a holistic manner by inculcating amongst the students the traditional and cultural values. The Institution strives to provide the young minds with a vision of a resplendent future and chisels their persona so as to prepare them as ideal citizens in service of society and the Nation.
                </p>
                <p>
                  The academic session is regulated as per the directions of the chair and the higher authorities. Different committees are formulated for smooth conduct of administrative and academic processes. The IQAC plays a pivotal role in planning these assignments and ensures their execution. Staff meetings are held almost every month, delegating assignments and responsibilities to teachers as well as student representatives for proper implementation of various activities.
                </p>
              </div>
            </div>
          </div>

          {/* Mission */}
          <div className="col-md-12 mt-4">
            <div className="committee-card">
              <div className="card-header">
                <h3 className="m-0">Institutional Mission: “FROM DARKNESS TO LIGHT”</h3>
              </div>
              &nbsp;
              <div className="card-body">
                <p>
                  The college is committed to the overall personality development of the students through innovative teaching-learning methods by adopting a diversified curriculum, making the students ready to contribute in nation-building and welfare of society when they leave the portals of the college.
                </p>
                <h5>Broad Objectives of the College:</h5>
                <ol>
                  <li>Provide students with market-relevant, need-specific, and latest academic programs to enhance their professional competence.</li>
                  <li>Create a conducive academic environment for students to develop skills for pursuing knowledge and become capable global citizens.</li>
                  <li>Provide best educational resources and infrastructure to convert them into confident and employable youth.</li>
                  <li>Involve students in activities that foster personal growth by inculcating ethical and human values.</li>
                  <li>Create a value-based knowledge society.</li>
                </ol>
              </div>
            </div>
          </div>

          {/* Enrolment Table */}
          <div className="row justify-content-center mb-5">
          <div className="col-md-12">
            <div className="committee-card">
              <div className="card-header text-center">
                <h3 className="m-0">Enrolment 2024-25</h3>
              </div>
              &nbsp;
              <div className="card-body d-flex justify-content-center">
                <table className="table table-bordered table-striped table-hover" style={{ width: "75%" }}>
                  <thead className="table-dark">
                    <tr>
                      <th>UG Classes</th>
                      <th>Male</th>
                      <th>Female</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr><td>BA-1st</td><td>21</td><td>26</td><td>47</td></tr>
                    <tr><td>BA-2nd</td><td>03</td><td>22</td><td>25</td></tr>
                    <tr><td>BA-3rd</td><td>02</td><td>37</td><td>39</td></tr>
                    <tr><td>B.Sc-1st</td><td>03</td><td>05</td><td>08</td></tr>
                    <tr><td>B.Sc-2nd</td><td>02</td><td>04</td><td>06</td></tr>
                    <tr><td>B.Sc-3rd</td><td>02</td><td>01</td><td>03</td></tr>
                    <tr><td>B.Com-1st</td><td>11</td><td>10</td><td>21</td></tr>
                    <tr><td>B.Com-2nd</td><td>03</td><td>07</td><td>10</td></tr>
                    <tr><td>B.Com-3rd</td><td>04</td><td>05</td><td>08</td></tr>
                    <tr><td>MA English 1st sem</td><td>00</td><td>01</td><td>01</td></tr>
                    <tr><td><strong>Total</strong></td><td>52</td><td>118</td><td>170</td></tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          </div>

        </div>
      </div>

      <Footer />
    </>
  );
}

export default Vision;
